import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-gallery-icon',
  templateUrl: './gallery.svg',
  styleUrls: ['./gallery-icon.component.scss'],
})
export class GalleryIconComponent implements OnInit {
  @Input() strokeColor = 'white';

  constructor() { }

  ngOnInit() {}

}
